module.exports = __webpack_public_path__ + "img/img_usine_connectee_retex.7a1181ab.png";